import { CommonMessages } from '../common.messages';

export const PanelOrdersMessages = {
    WrongAmountTo: {
        key: 'WrongAmountTo',
        message: 'Amount To must be greater than Amount From'
    },
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    ...CommonMessages
};
